import axios from "axios";

export const sendEmail = (email: any, recipients: any) => {
    axios.post('/.netlify/functions/sendEmail', {
        email,
        recipients: recipients.map( (email: any) => { return { email } }),
    }).then((data) => {
        console.log('Email sent', data);
    }).catch((err) => {
        console.error('An error occured sending the email.', err);
    })
}
